import { render, staticRenderFns } from "./BaseTextEditor.vue?vue&type=template&id=37812adb"
import script from "./BaseTextEditor.vue?vue&type=script&lang=js"
export * from "./BaseTextEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports